export interface HTMLCellContentProps {
    __html: string;
}

export default function HTMLCellContent(props: HTMLCellContentProps) {
    return <div dangerouslySetInnerHTML={props} />
}
